export const MOCK = false
export const DEMO_PHONE_NUMBER = "+10010020034"

export const sentryDsns = {
  ios: "https://d9b955779e489a7172035ac77e6b16e6@o4506854296125440.ingest.us.sentry.io/4507350389948416",
  android:
    "https://881d0d851782509c9efe95bb6aa5aa84@o4506854296125440.ingest.us.sentry.io/4507350397353984",
  web: "https://538670de6599e484fb7d8a77a58895b0@o4506854296125440.ingest.us.sentry.io/4507350463086592",
}

export const posthogHost = "https://us.i.posthog.com"
export const posthogAppHost = "https://us.posthog.com"
export const posthogKeyProd = "phc_ef9SMzhDH94wRPxF6hldKbb0GxzQg7Qe1Vvf8n917po"
export const posthogKeyNonProd = "phc_5loK1ZQvxP2t9js56i2Yy5y6N2w5SBlChzQocmbOgY4"
export const posthogProjectId = process.env.ENVIRONMENT === "production" ? "75522" : "139980"
